import React, { useRef, useEffect, useState } from "react";

const FadeModal = ({ show, onClose, children }) => {
    const modalRef = useRef();
    const [shouldRender, setShouldRender] = useState(show);
    const [animateClass, setAnimateClass] = useState("fade-zoom-in");

    useEffect(() => {
        if (show) {
            setShouldRender(true);
            setAnimateClass("fade-zoom-in");
        } else {
            setAnimateClass("fade-zoom-out");
            setTimeout(() => setShouldRender(false), 300); // Match animation duration
        }
    }, [show]);

    useEffect(() => {
        if (show) {
            modalRef.current?.focus();
        }
    }, [show]);

    return (
        <>
            {shouldRender && (
                <div
                    className={`modal fade show ${animateClass}`}
                    tabIndex="-1"
                    style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
                    aria-modal="true"
                    role="dialog"
                    ref={modalRef}
                    onClick={onClose}
                >
                    <div
                        className="modal-dialog modal-dialog-centered modal-lg"
                        onClick={e => e.stopPropagation()}
                    >
                        <div className="modal-content">
                            <div className="modal-body">{children}</div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FadeModal;
